import React from "react";
import HecRasHelper from "../Helpers/HecRasHelper";

const ProjectActions = {
    SET_BASE_PROJECT: 'SET_BASE_PROJECT',
    SET_COMPARE_PROJECT: 'SET_COMPARE_PROJECT',
    REMOVE_BASE_PROJECT: 'REMOVE_BASE_PROJECT',
    REMOVE_COMPARE_PROJECT: 'REMOVE_COMPARE_PROJECT',
    SET_PROJECT_HISTORY: 'SET_PROJECT_HISTORY',
    SET_INTERNAL_SELECTED_ID: 'SET_INTERNAL_SELECTED_ID',
    SET_SELECTED_REPORT_ID: 'SET_SELECTED_REPORT_ID',
    SET_COMPARISON_BASE_ID: 'SET_COMPARISON_BASE_ID',
    SET_COMPARISON_CMP_ID: 'SET_COMPARISON_CMP_ID',
    SET_FILTER: 'SET_FILTER',
    SET_SUMMARY: 'SET_SUMMARY',
    CLEAR_HISTORY: "CLEAR_HISTORY"
}

export const DefaultProject = {
    type: 'def',
    information: {
        folderName: '',
        title: '',
        descriptions: [],
        text: '',
        programVersion: '',
        outputColumns: [],
    },
    projectFiles: [],
    files: [],
}

const defaultValue = {
    baseProject: DefaultProject,
    compareProject: DefaultProject,
    projectHistory: [],
    projectSummaries: [],
    updateSummary: 0,
    internalSelectedId: '',
    comparisonBaseId: '',
    comparisonCmpId: '',
    selectedReportId: '',
    filterHistory: [],
    filter: {
        filterType: 'filter',
        check: {
            ds: null,
            us: null
        },
        comparison: {
            ds: null,
            us: null
        }
    }
}

const ProjectContext = React.createContext(defaultValue)

function projectReducer(state, action) {
    switch (action.type) {
        case ProjectActions.SET_BASE_PROJECT: {
            const plan = action.data.projectFiles.find(x => x.type === 'Effective')

            return {
                ...state,
                baseProject: {
                    ...action.data,
                    type: 'base'
                }
            }
        }
        case ProjectActions.SET_COMPARE_PROJECT: {
            const plan = action.data.projectFiles.find(x => x.type === 'Corrected Effective')

            return {
                ...state,
                compareProject: {
                    ...action.data,
                    type: 'compare'
                },
            }
        }
        case ProjectActions.REMOVE_BASE_PROJECT: {
            return {
                ...state,
                baseProject: DefaultProject,
            }
        }
        case ProjectActions.REMOVE_COMPARE_PROJECT: {
            return {
                ...state,
                compareProject: DefaultProject
            }
        }
        case ProjectActions.SET_PROJECT_HISTORY: {
            const history = action.data;
            const stateX = {
                ...state,
                projectHistory: action.data
            }

            if(action.data[history.length-1]) {
                stateX.selectedReportId = action.data[history.length-1].id
            }

            return stateX
        }
        case ProjectActions.SET_INTERNAL_SELECTED_ID: {
            return {
                ...state,
                internalSelectedId: action.data
            }
        }
        case ProjectActions.SET_COMPARISON_BASE_ID: {
            return {
                ...state,
                comparisonBaseId: action.data
            }
        }
        case ProjectActions.SET_COMPARISON_CMP_ID: {
            return {
                ...state,
                comparisonCmpId: action.data
            }
        }
        case ProjectActions.SET_SELECTED_REPORT_ID: {
            return {
                ...state,
                selectedReportId: action.data
            }
        }
        case ProjectActions.SET_FILTER: {
            const emptyFilter = {
                ds: null,
                us: null
            }

            let _state = {...state}

            _state.filter.filterType = action.data.filterType || 'filter'
            _state.filter.type = action.data.type

            let history = _state.projectHistory.find(x => x.id === action.data.id)
            let filter = {}

            if(action.data.type === 'check') {
                if(!_state.internalSelectedId)
                    _state.filter.check = emptyFilter
                else
                    _state.filter.check = action.data.filter

                filter = {
                    ..._state.filter.check,
                    filterType: action.data.filterType
                }
            }
            else {
                if(!_state.comparisonCmpId)
                    _state.filter.comparison = emptyFilter
                else
                    _state.filter.comparison = action.data.filter

                filter = {
                    ..._state.filter.comparison,
                    filterType: action.data.filterType
                }
            }

            if(history) {
                history.operations = HecRasHelper.filterResult({
                    operations: history.operations,
                    filter: {...action.data.filter, filterType: action.data.filterType}
                })
                history.filter = filter
            }

            // let index = _state.filterHistory.findIndex(x => x.id === action.data.id)
            // if(index > -1) {
            //     _state.filterHistory[index] = action.data
            // }
            // else {
            //     _state.filterHistory.push({
            //         ...action.data
            //     })
            // }

            return {
                ..._state
            }
        }
        case ProjectActions.SET_SUMMARY: {
            let _state = {...state}
            _state.updateSummary += 1;
            const index = _state.projectSummaries.findIndex(x => x.id === action.data.id)
            if(index >= 0) {
                _state.projectSummaries[index] = {
                    ..._state.projectSummaries[index],
                    id: action.data.id,
                    summary: action.data.summary
                }
            }
            else {
                _state.projectSummaries.push({
                    id: action.data.id,
                    summary: action.data.summary
                })
            }

            return {
                ..._state
            }
        }
        case ProjectActions.CLEAR_HISTORY: {
            return {
                ...state,
                projectHistory: []
            }
        }
        default: {
            return state
        }
    }
}

function ProjectProvider({children}) {
    const [project, dispatch] = React.useReducer(projectReducer, defaultValue)

    const value = {project, dispatch}

    return (
        <ProjectContext.Provider value={value}>
            {children}
        </ProjectContext.Provider>
    )
}

function useProject() {
    const context = React.useContext(ProjectContext)

    if(!context)
        throw new Error('Project Provider Error')

    const {project, dispatch} = context;

    const setBaseProject = (project) => {
        dispatch({
            type: ProjectActions.SET_BASE_PROJECT,
            data: project
        })
    }

    const setCompareProject = (project) => {
        dispatch({
            type: ProjectActions.SET_COMPARE_PROJECT,
            data: project
        })
    }

    const removeBaseProject = () => {
        dispatch({
            type: ProjectActions.REMOVE_BASE_PROJECT
        })
    }

    const removeCompareProject = () => {
        dispatch({
            type: ProjectActions.REMOVE_COMPARE_PROJECT
        })
    }

    const setProjectHistory = (history) => {
        dispatch({
            type: ProjectActions.SET_PROJECT_HISTORY,
            data: history
        })
    }

    const setInternalSelectedId = (id) => {
        dispatch({
            type: ProjectActions.SET_INTERNAL_SELECTED_ID,
            data: id
        })
    }

    const setComparisonBaseId = (id) => {
        dispatch({
            type: ProjectActions.SET_COMPARISON_BASE_ID,
            data: id
        })
    }

    const setComparisonCmpId = (id) => {
        dispatch({
            type: ProjectActions.SET_COMPARISON_CMP_ID,
            data: id
        })
    }

    const setSelectedReportId = (id) => {
        dispatch({
            type: ProjectActions.SET_SELECTED_REPORT_ID,
            data: id
        })
    }

    const setFilter = ({id, filter, type, filterType}) => {
        dispatch({
            type: ProjectActions.SET_FILTER,
            data: {id, filter, type, filterType}
        })
    }

    const setSummary = ({id, summary}) => {
        dispatch({
            type: ProjectActions.SET_SUMMARY,
            data: {id, summary}
        })
    }

    const clearHistory = () => {
        dispatch({
            type: ProjectActions.CLEAR_HISTORY,
        })
    }

    const getMinMaxCS = () => {

    }

    return {
        baseProject: project.baseProject,
        compareProject: project.compareProject,
        projectHistory: project.projectHistory,
        internalSelectedId: project.internalSelectedId,
        comparisonBaseId: project.comparisonBaseId,
        comparisonCmpId: project.comparisonCmpId,
        selectedReportId: project.selectedReportId,
        filter: project.filter,
        filterHistory: project.filterHistory,
        summaries: project.projectSummaries,
        updateSummary: project.updateSummary,
        setBaseProject,
        setCompareProject,
        removeBaseProject,
        removeCompareProject,
        setProjectHistory,
        setInternalSelectedId,
        setComparisonBaseId,
        setComparisonCmpId,
        setFilter,
        setSelectedReportId,
        setSummary,
        clearHistory
    }
}

export {ProjectProvider, useProject}